export function getCostColor(cost) {
	if (cost === 0) {
		return undefined;
	}

	return cost > 0 ? "green" : "red";
}
